/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function () {
  function check_timing() {

    var daysOfWeek = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
    
    var elementCounter = $("[data-js-delivery-countdown-counter]");
    var elementDelivery = $("[data-js-delivery-countdown-delivery]");
    var deliveryTime = parseInt($('delivery-countdown').attr("data-delivery-time"));
    var resetTime = parseInt($('delivery-countdown').attr("data-reset-time"));
    var deliveryFormat = $('delivery-countdown').attr("data-delivery-format");
    var deliver_exclude = $('delivery-countdown').attr("data-delivery-excludes").replace(' ','');
    console.log("elementCounter", deliver_exclude);
    var excludes = deliver_exclude.toLowerCase().split(",");

    function CountTime(){
      var now = new Date();
    
      var finalDate = new Date();
      
      finalDate.setDate(finalDate.getDate() + 1);
      finalDate.setHours(resetTime, 0, 0, 0);

      var counterTotal = Date.parse(finalDate) - Date.parse(new Date());
      var counterMinutes = Math.floor((counterTotal / 1000 / 60) % 60);
      var counterHours = Math.floor((counterTotal / (1000 * 60 * 60)) % 24);

      var finalyDeliveryTime = deliveryTime;
      var startExcludesDate = 0;
      
      if (now.getHours() >= finalDate.getHours() && now.getMinutes() >= finalDate.getMinutes() && now.getSeconds() >= finalDate.getSeconds()) {
        finalyDeliveryTime++;
        startExcludesDate++;
      }

      var deliveryDate = now;
      
      var endExcludesDate = deliveryTime + startExcludesDate + 1;
      
      for (var i = startExcludesDate; i < endExcludesDate; i++) {
        var currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + i);
        if (excludes.indexOf(daysOfWeek[currentDate.getDay()].toLowerCase()) !== -1) {
            deliveryDate.setDate(deliveryDate.getDate() + 1);
            endExcludesDate++;
        }
      }

      deliveryDate.setDate(deliveryDate.getDate() + finalyDeliveryTime);
      var counterHTML = '';
    
      if(counterHours) {
        counterHTML += `${counterHours} hours `;
      }
      counterHTML += `${counterMinutes} minutes`;
      elementCounter.html(counterHTML);
      elementDelivery.html(deliveryFormat.toLowerCase()
          .replace('day', daysOfWeek[deliveryDate.getDay()])
          .replace('dd', ('0' + deliveryDate.getDate()).slice(-2))
          .replace('mm', ('0' + (deliveryDate.getMonth() + 1)).slice(-2))
          .replace('yyyy', deliveryDate.getFullYear())
          .replace('yy', deliveryDate.getFullYear().toString().slice(-2)));
    }
    setInterval(function() {
      CountTime()
    }, 2000);
  }
  if($("[data-js-delivery-countdown-delivery]").length > 0 && $("[data-js-delivery-countdown-counter]").length > 0){
    check_timing();
  }

  $('body').on('click','.product_custom_tabs_inner .tab_head',function(e){
    e.preventDefault();
    var id = $(this).attr('data-id');
    if($(window).width() < 1000){
      if($(this).hasClass('is-active')){
        $(this).parents('.product_custom_tabs_inner').find('.tab_head').removeClass('is-active');
        $(this).parents('.product_custom_tabs_inner').find('.content').removeClass('is-active').slideUp();
      }else{
        $(this).parents('.product_custom_tabs_inner').find('.tab_head').removeClass('is-active');
        $(this).parents('.product_custom_tabs_inner').find('.content').removeClass('is-active').slideUp();
        $(this).addClass('is-active');
        $(this).parents('.product_custom_tabs_inner').find('#'+id).addClass('is-active').slideDown();
      }
    }else{
      $(this).parents('.product_custom_tabs_inner').find('.tab_head').removeClass('is-active');
      $(this).parents('.product_custom_tabs_inner').find('.content').removeClass('is-active');
      $(this).addClass('is-active');
      $(this).parents('.product_custom_tabs_inner').find('#'+id).addClass('is-active');
    }
    
  });
  $('body').on('click','.buy_more_grid.trigger_to_quote',function(e){
    if($('.product-form__add-button[type="button"]').length > 0){
      $('.product-form__add-button[type="button"]').trigger('click');
    }
  });
  $('.product-landing .buymorebtn,.buymorebtn_overlay, .proentire-visible .buymorebtn,.buymorebtn_overlay').click(function(){
      $('body').toggleClass('openbuymore');
  });
  if($('.product-meta__text.rte p:first-child a').length > 0){
    $('.product-meta__text.rte p:first-child a').closest('.product-meta__text.rte').addClass('hide_mobile');
  }

  // if(document.querySelectorAll('.slp-sdrop') != undefined && document.querySelectorAll('.slp-sdrop') != null){

  //   function changedropdown(url){
  //     fetch(url)
  //       .then(function (response) {
  //           switch (response.status) {
  //               // status "OK"
  //               case 200:
  //                   return response.text();
  //               // status "Not Found"
  //               case 404:
  //                   throw response;
  //           }
  //       })
  //       .then(function (ctemplate) {
  //           // console.log(template);
  //           var cdoc = document.createElement('html');
  //           cdoc.innerHTML = ctemplate;
  //           console.log(cdoc.querySelector('.search-drpdwn-list'),'~~~~~~~~~~~~~~~~');
  //           document.querySelector('.search-drpdwn-list').innerHTML = cdoc.querySelector('.search-drpdwn-list').innerHTML;
  //           // cdoc.querySelectorAll('.search-drpdwn-list .search-drpdwn-wrp:not(.search-drpdwn-btn)').forEach(function(button) {
  //           //   var getselected = button.querySelector('select');
              
  //           //   var name = getselected.getAttribute('name');
  //           //   var svalue = getselected.value;
  //           //   if(svalue != undefined && svalue != ''){
  //           //     url.searchParams.append(name, svalue);
  //           //     currenturl.searchParams.append(name, svalue);
  //           //     // console.log('####',url);
  //           //   }
  //           // });
            
  //       })
  //       .catch(function (response) {
  //           // "Not Found"
  //           console.log(response);
  //       });
  //   }
    
  //   var allslp = document.querySelectorAll('.slp-sdrop');
  
  //   allslp.forEach(el => el.addEventListener('change', event => { 
  //       event.preventDefault();
  //       var element = document.querySelector(".loading-bar");
  //       element.classList.add("is-visible");
  //       element.style.transform = "scaleX(0.4)";
  //       var geturl = document.querySelector('.main-search-landing-wrp');
  //       var uu = geturl.getAttribute('data-colurl');
  //       var url = new URL(uu);

  //       var currentuu = geturl.getAttribute('datacurrenturl');
  //       var currenturl = new URL(currentuu);
  //       document.querySelectorAll('.search-drpdwn-list .search-drpdwn-wrp:not(.search-drpdwn-btn)').forEach(function(button) {
  //         var getselected = button.querySelector('select');
  //         var name = getselected.getAttribute('name');
  //         var svalue = getselected.value;
  //         if(svalue != undefined && svalue != ''){
  //           url.searchParams.append(name, svalue);
  //           currenturl.searchParams.append(name, svalue);
  //           // console.log('####',url);
  //         }
  //       });
        
  //       fetch(url)
  //       .then(function (response) {
  //           switch (response.status) {
  //               // status "OK"
  //               case 200:
  //                   return response.text();
  //               // status "Not Found"
  //               case 404:
  //                   throw response;
  //           }
  //         element.style.transform = "scaleX(1)";
  //         element.classList.add("is-finished");
  //       })
  //       .then(function (template) {
  //           // console.log(template);
  //           var doc = document.createElement('html');
  //           doc.innerHTML = template;
          
  //         document.querySelector('.slp-cg-list-wrp .cardadd').classList.add('card');
  //         if(doc.querySelector('.product-list') != null && doc.querySelector('.product-list') != ''){
  //           console.log(doc.querySelector('.search-drpdwn-list'),'*******************');
  //           changedropdown(currenturl);
  //           document.querySelector('.search-landing-product-list ').innerHTML = doc.querySelector('.product-list').innerHTML;
  //         }else{
  //           document.querySelector('.search-landing-product-list ').innerHTML = '<div class="empty-state"><p class="empty-state__description">Your criteria did not match any products. Try Another data.</p></div>'
  //         }
  //         element.classList.remove("is-visible");
  //         element.classList.remove("is-finished");
  //         element.style.transform = "scaleX(0)";
            
  //       })
  //       .catch(function (response) {
  //           // "Not Found"
  //           console.log(response);
  //         element.classList.remove("is-visible");
  //         element.classList.remove("is-finished");
  //         element.style.transform = "scaleX(0)";
  //       });
  //   }));
  // }

  if($('.slp-sdrop').length > 0){

    function changedropdown(url,element){
      $.ajax({
       url:url,
       type:'GET',
       async: false,
       success: function(cdata){
          $('.search-drpdwn-list').html($(cdata).find('.search-drpdwn-list').html());
          element.style.transform = "scaleX(1)";
          element.classList.add("is-finished");
          $('.search-drpdwn-list .search-drpdwn-wrp select').prop("disabled",false);
       }
      });
    }
    $('body').on('click','.slp-cg-list-wrp .pagination .pagination__nav-item,.slp-cg-list-wrp .pagination .pagination__next,.slp-cg-list-wrp .pagination .pagination__prev',function(e){
      e.preventDefault();
      var element = document.querySelector(".loading-bar");
      element.classList.add("is-visible");
      element.style.transform = "scaleX(0.4)";

      $('.slp-cg-list-wrp').find('.pagination').remove();
      var pageindex = parseInt($(this).attr('data-page'));
      var geturl = $('.main-search-landing-wrp').attr('data-colurl');
      var url = new URL(geturl);
      url.searchParams.append('page', pageindex);
      $('.search-drpdwn-list .search-drpdwn-wrp:not(.search-drpdwn-btn)').each(function(button) {
        var name = $(this).find('select').attr('name');
        var svalue = $(this).find('select').val();
        if(svalue != undefined && svalue != ''){
          url.searchParams.append(name, svalue);
          // console.log('####',url);
        }
      });
      $.ajax({
         url:url,
         type:'GET',
         success: function(gdata){
            $('.slp-cg-list-wrp .cardadd').addClass('card');
            if($(gdata).find('.product-item ').length > 0){
              $('.search-landing-product-list ').html($(gdata).find('.product-list').html());
              if($(gdata).find('.pagination').length > 0){
                $('.search-landing-product-list ').after('<div class="pagination">'+$(gdata).find('.pagination').html()+'</div>');
              }
            }else{
              $('.search-landing-product-list').html('');
            }
            element.classList.remove("is-visible");
            element.classList.remove("is-finished");
            element.style.transform = "scaleX(0)";
            $('html, body').stop().animate({scrollTop: $('.slp-cg-list-wrp').offset().top});
         }
      });
      
    });
    
    $('body').on('change','.slp-sdrop',function(e){
      e.preventDefault();
      var element = document.querySelector(".loading-bar");
      element.classList.add("is-visible");
      element.style.transform = "scaleX(0.4)";
      $('.search-drpdwn-list .search-drpdwn-wrp select').prop("disabled",true);
      $('.slp-cg-list-wrp').find('.pagination').remove();

      var geturl = $('.main-search-landing-wrp').attr('data-colurl');
      var url = new URL(geturl);

      var currentuu = $('.main-search-landing-wrp').attr('datacurrenturl');
      var currenturl = new URL(currentuu);
      var cnt = 0;
      $('.search-drpdwn-list .search-drpdwn-wrp:not(.search-drpdwn-btn)').each(function(button) {
        var name = $(this).find('select').attr('name');
        var svalue = $(this).find('select').val();
        if(svalue != undefined && svalue != ''){
          cnt++;
          url.searchParams.append(name, svalue);
          currenturl.searchParams.append(name, svalue);
          // console.log('####',url);
        }
      });
      
      if(cnt > 0){
        $.ajax({
           url:url,
           type:'GET',
           success: function(gdata){
              $('.slp-cg-list-wrp .cardadd').addClass('card');
              if($(gdata).find('.product-item ').length > 0){
                changedropdown(currenturl,element);
                $('.search-landing-product-list ').html($(gdata).find('.product-list').html());
                if($(gdata).find('.pagination').length > 0){
                  $('.search-landing-product-list ').after('<div class="pagination">'+$(gdata).find('.pagination').html()+'</div>');
                }
              }else{
                $('.search-landing-product-list').html('<div class="empty-state"><p class="empty-state__description">Your criteria did not match any products. Try Another data.</p></div>');
              }
              element.classList.remove("is-visible");
              element.classList.remove("is-finished");
              element.style.transform = "scaleX(0)";
            
           }
        });
      }else{
        changedropdown(currenturl,element);
        $('.search-landing-product-list').html('');
        $('.slp-cg-list-wrp .cardadd').removeClass('card');
        element.classList.remove("is-visible");
        element.classList.remove("is-finished");
        element.style.transform = "scaleX(0)";
      }
      
      
    });
  }
  
  $('body').on('click','.customaccordion-wrp .accordion-title',function(){
    if($(this).parents('.accordion-inner').hasClass('open')){
      $(this).parents('.accordion-inner').removeClass('open');
      $(this).parents('.accordion-inner').find('.accordion-content').slideUp();
    }else{
      $('.customaccordion-wrp .accordion-inner').removeClass('open');
      $('.customaccordion-wrp .accordion-inner').find('.accordion-content').slideUp();
      $(this).parents('.accordion-inner').addClass('open');
      $(this).parents('.accordion-inner').find('.accordion-content').slideDown();
      if($(this).parents('.accordion-inner').find('product-recommendations').length > 0){
        setTimeout(function(){
          // console.log('entire_visible_comply_flick',entire_visible_comply_flick);
          entire_visible_comply_flick.resize();
        },1000);
      }
    }
  });

  $('body').on('click','.table-format-collection .quantity-selector--product .quantity-selector__button',function(e){
    e.preventDefault();
    var inp = $(this).parent().find('[name="quantity"]');
    var qty = parseInt(inp.val());
    if($(this).attr('data-action') == 'increase-picker-quantity'){
      qty++;
    }else{
      if(qty > 1){
        qty--;
      }
    }
    inp.val(qty);
    inp.parents('tr').find('[name="quantity"]').val(qty);
  });
  $('body').on('click','.quantity-selector--product.fcolqty-and-addbtn .quantity-selector__button',function(e){
    e.preventDefault();
    var inp = $(this).parent().find('[name="quantity"]');
    var qty = parseInt(inp.val());
    if($(this).attr('data-action') == 'increase-picker-quantity'){
      qty++;
    }else{
      if(qty > 1){
        qty--;
      }
    }
    inp.val(qty);
  });
  $('body').on('click','.table .colorselectorbox .mainseleted_val',function(){
    var posi = $(this)[0].getBoundingClientRect();
    if($(this).parent('').find('.colordroplist').hasClass('open')){
      $(this).parents('tbody').find('.colordroplist').removeClass('open');
      $('html').removeClass('stopscrolling');
    }else{
      $(this).parent().find('.colordroplist').css('top',posi.bottom);
      $(this).parent().find('.colordroplist').css('left',posi.left);
      $(this).parents('tbody').find('.colordroplist').removeClass('open');
      $(this).parent().find('.colordroplist').addClass('open');
      $('html').addClass('stopscrolling');
    }
  });
  $('body').on('click','.table .colorselectorbox .table-colordropdown',function(e){
    e.preventDefault();
    var oval = $(this).attr('data-value');
    $(this).parents('tbody').find('.colordroplist').removeClass('open');
    $('html').removeClass('stopscrolling');

    var chgeopt = $(this).parents('.totaloption').attr('data-optname');
    // $(this).parents('.totaloption').find('.mainseleted_val .inner').html($(this).html());
    $(this).parents('tr').find('.totaloption[data-optname="'+chgeopt+'"] .mainseleted_val .inner').html($(this).html());
    $(this).parents('tr').find('.totaloption[data-optname="'+chgeopt+'"]').find('.table-colordropdown').removeClass('selected');
    $(this).parents('tr').find('.totaloption[data-optname="'+chgeopt+'"] .colordroplist li[data-value="'+oval+'"]').addClass('selected');
    var optname='';
    $(this).parents('tr').find('.mob_list_color .totaloption').each(function(){
      var opt = $(this).find('.table-colordropdown.selected').attr('data-value');
      if(optname ==''){
        optname = opt; 
      }else{
        optname = optname + ' / ' + opt;
      }
    });
    
    var vid = $(this).parents('tr').find(".variantlist option[value='"+optname+"']").attr('data-id');
    var imgid = $(this).parents('tr').find(".variantlist option[value='"+optname+"']").attr('data-img-url');
    if(imgid){
      $(this).parents('tr').find('.mob_table_data.leftside .img-sec img').attr('src',imgid);
    }
    var eachprice = $(this).parents('tr').find(".variantlist option[value='"+optname+"']").attr('data-price-each');
    $(this).parents('tr').find(".variantlist option[value='"+optname+"']").prop('selected', true);
    $(this).parents('tr').find('form [name="id"]').val(vid);
    $(this).parents('tr').find('.seteachcarton-price').text(eachprice);
    // console.log('vtitle= ',optname);
  });
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.colorselectorbox').length)  {
      $('.table tbody').find('.colordroplist').removeClass('open');
      $('html').removeClass('stopscrolling');
    }
  });
  $('body').on('click','.table-complyoverlay ,.my_product-recommendations .complypop-close',function(){
    $('.table-template-complementary').toggleClass('open');
  });
});
